<template>
    <div>
          <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <!-- <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div> -->
        <!-- <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">About Us</h1>
              </div>
            </div>
          </div>
        </div> -->
      </section>
      <!-- 1st Hero Variation -->

       <!-- <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-8">
                        <h2 class="display-3">Connect with Us</h2>
                        <p class="lead text-muted">There are various ways to connect with us for any queries, 
                            Please check information below to connect with us or 
                            fill out the form given to get a response within 24 hours.</p>
                    </div>
                </div>
            </div>
        </section> -->

          <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Connect with Us</h2>
                        <!-- <h2 class="display-3 text-white">Deepak Travel World (FollowMeTraveller.in or HotelLele.com)</h2> -->
                        <p class="lead text-white">You can reach us on below given details for any queries on our Services at Deepak Travel World, FollowMeTraveller and HotelLele.com</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-email-83" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Email</h5>
                        <p class="text-white mt-3">support@hotellele.com, deepaktravelworld@gmail.com</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-mobile-button" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Call us</h5>
                        <p class="text-white mt-3">+91 - 80805 40540, +91 - 91522 16606.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-map-big" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Meet Us</h5>
                        <p class="text-white mt-3">Shop No. 1, Manish Tower, Near Kanwarram Chowk, Station Road, Ulhasnagar 3, Ulhasnagar, Maharashtra 421003. INDIA.</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to travel the world?</h4>
                            <p class="mt-0">Please fill out the form below, we will get back to you shortly.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                                              cols="80" placeholder="Type your query..."></textarea>
                            </base-input>
                            <base-button type="default" round block size="lg">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>


    </div>    
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>